export type GetLabsBookingOutcome =
  | "rejected"
  | "unknown"
  | "not_created"
  | "conflict";

export class GetLabsBookingError extends Error {
  constructor(
    public readonly bookingOutcome: GetLabsBookingOutcome,
    public readonly httpStatus: number,
  ) {
    super(`GetLabs booking failed with outcome ${bookingOutcome}`);
    this.name = "GetLabsBookingError";
  }
}
